import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { convertAfToPkSpelling } from "../lib/convert-spelling";
import { phoneticsToDiacritics } from "../lib/phonetics-to-diacritics";

var Pashto = function Pashto(_ref) {
  var opts = _ref.opts,
      text = _ref.children;
  var p = opts.diacritics ? phoneticsToDiacritics(text.p, text.f) || text.p : text.p;
  var style = opts.pTextSize === "normal" ? undefined : {
    fontSize: opts.pTextSize === "larger" ? "large" : "larger"
  };
  return _jsx("span", Object.assign({
    className: "p-text",
    dir: "rtl",
    style: style
  }, {
    children: opts.spelling === "Afghan" ? p : convertAfToPkSpelling(p)
  }), void 0);
};

export default Pashto;